import React, { useEffect } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";

import AuthScreen from "./screens/AuthScreen";
import HomeScreen from "./screens/HomeScreen";
import BathroomScreen from "./screens/BathroomScreen";
import PartnerHomeScreen from "./screens/PartnerHomeScreen";
import Layout from "./components/Layout";

import HostlandingPage from "./screens/HostlandingPage";
import GuestProfile from "./screens/GuestProfile";

import PartnerHomeScreenDemo from "./screens/PartnerHomeScreenDemo";
import GuestProfileDemo from "./screens/GuestProfileDemo";
import HomeScreenDemo from "./screens/HomeScreenDemo";
import PartnerAnalytics from "./screens/PartnerAnalytics";

import MyPass from "./screens/MyPass";

import PrivacyPolicy from "./screens/PrivacyPolicy";
import TermsOfService from "./screens/TermsofService";
import Eula from "./screens/Eula";
import RefundPolicy from "./screens/RefundPolicy";

import ChatScreen from "./screens/ChatScreen";
import NotificationsScreen from "./screens/NotificationsScreen";

import NightlifeLandingScreen from "./screens/NightlifeLandingScreen";
import AccessLandingScreen from "./screens/AccessLandingScreen";
import WelcomeScreen from "./screens/WelcomeScreen";
import ReferralAdminDashboard from "./screens/ReferralAdminDashboard";
import ReferralLandingPage from "./screens/ReferralLandingPage";
import ReferralApplyScreen from "./screens/ReferralApplyScreen";
import DownloadPage from "./screens/DownloadPage";

// If you’re using this, render it (or remove the import)
// import RouteTracker from "./analytics/RouteTracker";

import { App as CapApp } from "@capacitor/app";

export default function App() {
  useEffect(() => {
    // Only run in Capacitor (prevents weird web behavior)
    const isNativeCapacitor =
      typeof window !== "undefined" &&
      window.Capacitor &&
      window.Capacitor.getPlatform &&
      window.Capacitor.getPlatform() !== "web";

    if (!isNativeCapacitor) return;

    const sub = CapApp.addListener("appUrlOpen", (data) => {
      const url = data?.url || "";

      // example: pay2pee://app/mypass?session_id=abc
      if (url.includes("://app/mypass")) {
        const q = url.split("/mypass")[1] || "";
        window.location.hash = `#/mypass${q}`;
        return;
      }

      if (url.includes("://app/home")) {
        window.location.hash = "#/home";
      }
    });

    return () => {
      // Capacitor listeners return an object with remove() in newer versions
      try {
        sub?.remove?.();
      } catch {
        // no-op
      }
    };
  }, []);

  return (
    <AuthProvider>
      <Router>
        {/* If you use RouteTracker, it should be rendered here */}
        {/* <RouteTracker /> */}

        <Layout>
          <Routes>
            {/* Auth / entry */}
            <Route path="/" element={<AuthScreen />} />

            {/* Guest side */}
            <Route path="/home" element={<HomeScreen />} />
            <Route path="/bathrooms" element={<BathroomScreen />} />
            <Route path="/guest" element={<GuestProfile />} />

            {/* Partner side */}
            <Route path="/partner" element={<PartnerHomeScreen />} />
            <Route path="/partner/analytics" element={<PartnerAnalytics />} />

            {/* Host landing page */}
            <Route path="/host" element={<HostlandingPage />} />

            {/* MyPass */}
            <Route path="/mypass" element={<MyPass />} />

            {/* Demo routes */}
            <Route path="/home.d" element={<HomeScreenDemo />} />
            <Route path="/partner.d" element={<PartnerHomeScreenDemo />} />
            <Route path="/guest.d" element={<GuestProfileDemo />} />

            {/* Legal routes */}
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/eula" element={<Eula />} />
            <Route path="/refunds" element={<RefundPolicy />} />

            {/* Chat / notifications */}
            <Route path="/chat" element={<ChatScreen />} />
            <Route path="/notifications" element={<NotificationsScreen />} />

            {/* marketing pages routes */}
            <Route path="/nightlife" element={<NightlifeLandingScreen />} />
            <Route path="/access" element={<AccessLandingScreen />} />
            <Route path="/welcome" element={<WelcomeScreen />} />
            <Route path="/download" element={<DownloadPage />} />

            {/* Fallback: any unknown route -> Auth (keep LAST) */}
            <Route path="*" element={<AuthScreen />} />
            
            {/* referral page routes */}
            <Route path="/referrals" element={<ReferralLandingPage />} />
            <Route path="/admin/referrals" element={<ReferralAdminDashboard />} />
            <Route path="/referrals/apply" element={<ReferralApplyScreen />} />
          </Routes>
        </Layout>
      </Router>
    </AuthProvider>
  );
}